import React from "react";
import Reveal, { RevealGroup, RevealItem, SplitTitle } from "../ui/Reveal";
import useLang from "../../hooks/useLang";

// Why Applumo: the promise and its six reasons.
const WhyApplumoSection = () => {
  const { t } = useLang();
  const reasons = t("whyApplumo.reasons", { returnObjects: true });

  return (
    <section className="py-16 sm:py-20 bg-paper">
      <div className="container-site">
        <Reveal className="max-w-3xl mb-10">
          <span className="eyebrow text-rose-dark">{t("whyApplumo.badge")}</span>
          <SplitTitle text={t("whyApplumo.title")} className="h-section text-ink mt-4" />
          <p className="lead text-zinc-500 mt-5">{t("whyApplumo.intro")}</p>
        </Reveal>
        <RevealGroup className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-12">
          {reasons.map((reason, i) => (
            <RevealItem key={i} className="border-t border-zinc-300 pt-6">
              <span className="font-mono text-[11px] tracking-[0.16em] text-rose-dark">0{i + 1}</span>
              <h3 className="text-lg font-extrabold text-ink mt-3 tracking-[-0.01em]">{reason.title}</h3>
              <p className="text-zinc-500 leading-relaxed mt-2">{reason.desc}</p>
            </RevealItem>
          ))}
        </RevealGroup>
      </div>
    </section>
  );
};

export default WhyApplumoSection;
